import { memo, useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import _filter from 'lodash/filter';
// Local files
import { Root, UnselectedContainer } from './Patients.styled';
import PatientsList from 'components/Patients/List/List';
import Conversation from 'components/Patients/Details/Conversation/Conversation';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useCustomSelector from 'hooks/useCustomSelector';
import usePatients from 'hooks/usePatients';
import useConversations from 'hooks/useConversations';
import useMessages from 'hooks/useMessages';
import { patientsSelectors } from 'features/patients';

const Patients = () => {
  const { patient_id } = useParams();
  const { getConversations } = useConversations();
  const { getMessages } = useMessages();
  const { getPatient } = usePatients();
  const { id } = useCustomSelector(patientsSelectors.getPatientData);
  const loading = useCustomSelector(patientsSelectors.patientIsFetching);

  const fetchPatient = useCallback((id) => {
    getPatient({ id })
    .then(({ payload, error }) => {
      if (!error) {
        const { data: { patient: { source } } } = payload;
        getConversations({ offset: 0, patient_id: id, source })
        .then(({ payload, error }) => {
          if (!error) {
            const { data: { conversations } } = payload;
            const defaultConversation = _filter(conversations, { channel: source });
            getMessages({ 
              conversation_id: defaultConversation[0].id, 
              senders: defaultConversation[0]?.mode === 'manual' ? ['patient', 'manager'] : ['patient', 'manager', 'bot']
            })
          }
        })
      }
    })
  }, [getPatient, getConversations, getMessages]);

  useEffect(() => {
    !!patient_id && id !== patient_id && fetchPatient(patient_id);
  }, [id, patient_id, fetchPatient]);

  return (
    <Root>
      <PatientsList />
      {!patient_id ? <UnselectedContainer>
        {loading ? <CircularProgress /> : <Typography variant='h5'>Please select a patient...</Typography>}
      </UnselectedContainer> : <Conversation /> }
    </Root>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <Patients {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);